import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import HeroTimelineCard from "./HeroTimelineCard";
import { TIMELINE_STEPS } from "./heroContent";

const HeroTimeline = () => {
  const reduceMotion = useReducedMotion();

  return (
    <div className="mt-8 lg:mt-0" data-testid="hero-timeline">
      <div className="flex flex-col gap-4">
        {TIMELINE_STEPS.map((step, index) => (
          <motion.div
            key={step.id}
            initial={reduceMotion ? false : { opacity: 0, x: -12 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <HeroTimelineCard step={step} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default HeroTimeline;
